import { render } from "./ShowUser.vue?vue&type=template&id=2a474c16"
import script from "./ShowUser.vue?vue&type=script&lang=js"
export * from "./ShowUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__